type Props = {
    avatarLink?: string
}

const BaseAvatar = (props:Props)=>{
    const { avatarLink } = props
    if(!avatarLink) {
        return <i className="bi-person-circle text-gray-500"  style={{position: 'relative', fontSize: '50px', lineHeight: 1, filter: "drop-shadow(2px 2px 3px rgba(0,0,0,0.4))"}} />
    }

    return <i className="bi-circle text-gray-500"  style={{position: 'relative', fontSize: '50px', lineHeight: 1, filter: "drop-shadow(2px 2px 3px rgba(0,0,0,0.4))"}}>
                <img src={props.avatarLink} alt="User Avatar" style={{borderRadius: '50%', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '40px', height: '40px'}} />
            </i>
}

export default BaseAvatar